export const DRIVER_DETAILS_SCREEN = '/';
export const DRIVER_DETAILS_SCREEN_SITE = '/:siteNumber';
export const TRACKING_DETAILS_SCREEN = '/tracking-details';
export const FUAL_TYPE_DETAILS_SCREEN = '/fuel-type';
export const SUCCESS_DETAILS = '/success-details';